import { useQuery, QueryResult } from '@apollo/client';
import {
  GetAllTenantFeatureFlagsQuery,
  GetAllTenantFeatureFlagsQueryVariables,
} from '__generated__/graphql';
import { GET_ALL_TENANT_FEATURE_FLAGS } from 'graphql/tenants/queries/getAllTenantFeatureFlags.gql';

export const useGetAllTenantFeatureFlags = (
  tenantId: number
): QueryResult<GetAllTenantFeatureFlagsQuery, GetAllTenantFeatureFlagsQueryVariables> => {
  return useQuery(GET_ALL_TENANT_FEATURE_FLAGS, {
    variables: {
      input: {
        tenantId,
      },
    },
    skip: !tenantId,
  });
};
